import React from "react";

export default function TextArea(props) {
  const { form, field } = props;
  return (
    <div className="text-xs mt-2">
      <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2 text-white"
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <textarea
        className="border-0 px-3 py-3 form-control placeholder-blueGray-300 text-blueGray-600 bg-violet-50 rounded text-xs shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 text-white"
        name={field.name}
        placeholder={props.placeholder}
        {...field}
        rows={props.rows ?? 4}
      />
      <span className="text-xs text-red-400">
        {form.errors[field.name] &&
          form.touched[field.name] &&
          form.errors[field.name]}
      </span>
    </div>
  );
}
